let mapper_options = {
  endpoint: 'users',
  recordClass: require('./record'),
  relations: {
    hasMany: {
      retailer_account: {
        localKeys: 'retailer_accounts_ids',
        localField: 'retailer_accounts'
      },
      registration_key: {
        foreignKey: 'user_id',
        localField: 'registration_keys'
      },
      brand_request: [
        {
          foreignKey: 'user_id',
          localField: 'users'
        },
        {
          foreignKey: 'assignee_id',
          localField: 'assignees'
        }
      ],
      note: {
        foreignKey: 'user_id',
        localField: 'notes'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('user', mapper_options)
}
